export const supportedBreakpoints = [
  'xxxs',
  'xxs',
  'xs',
  'sm',
  'md',
  'lg',
  'xlg',
  'xxlg',
] as const;

export type supportedBreakpointsTypes =
  | 'xxxs'
  | 'xxs'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xlg';
